var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepper1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340.586,
    height: 163.226,
    viewBox: "0 0 340.586 163.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6317",
    "data-name": "Group 6317",
    transform: "translate(-361.481 -182.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_tick_3923816",
    transform: "translate(390.191 186.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3432",
    "data-name": "Path 3432",
    d: "M19.682,2A17.682,17.682,0,1,0,37.365,19.682,17.682,17.682,0,0,0,19.682,2ZM29.719,16.565,19.109,26.29a1.768,1.768,0,0,1-2.445-.053l-5.3-5.3a1.768,1.768,0,1,1,2.5-2.5l4.107,4.108,9.361-8.581a1.768,1.768,0,1,1,2.391,2.606Z",
    transform: "translate(-2 -2)",
    fill: "#f37320"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6085",
    "data-name": "Group 6085",
    transform: "translate(441.835 295.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3484",
    "data-name": "Path 3484",
    d: "M11487.514,19508.41l5.956,1.82v15.523l-5.956-6.4Z",
    transform: "translate(-11480.767 -19505.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5699",
    "data-name": "Group 5699",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Pencil_811378",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5698",
    "data-name": "Group 5698",
    transform: "translate(34.6 1.723) rotate(93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3430",
    "data-name": "Path 3430",
    d: "M32.4,6.784h0L26.284.7l-.11-.11A2.013,2.013,0,0,0,23.535.407a2.371,2.371,0,0,0-.33.293L2.974,20.894a2.16,2.16,0,0,0-.623,1.539h0c-.037.11-.11.22-.147.33L.042,31.046a2.09,2.09,0,0,0-.037.476,1.244,1.244,0,0,0,.367.99,1.312,1.312,0,0,0,.916.4h.22a1.375,1.375,0,0,0,.367-.037l8.32-1.979a1.136,1.136,0,0,0,.476-.22,2.2,2.2,0,0,0,1.5-.623L32.4,9.826a2.135,2.135,0,0,0,.586-1.979A2.787,2.787,0,0,0,32.4,6.784Zm-8.063-5.2a.551.551,0,0,1,.4-.147.589.589,0,0,1,.4.183l.11.11L31.342,7.81l.037.037a.621.621,0,0,1,0,.843l-2.822,2.822a.621.621,0,0,1-.843,0L21.483,5.281a.535.535,0,0,1,0-.806Zm1.942,12.241a.621.621,0,0,1-.843,0L19.21,7.59a.621.621,0,0,1,0-.843l.953-.953a1.723,1.723,0,0,0,.33.44l6.231,6.231h0a1.652,1.652,0,0,0,.513.367ZM4.037,30.9,2.095,28.921,3.3,24.266l5.5,5.5Zm7.11-1.869a.752.752,0,0,1-1.063,0L4,22.947a.724.724,0,0,1-.22-.513A.665.665,0,0,1,4,21.92L17.854,8.067a4.774,4.774,0,0,0,.367.55l6.231,6.231a1.45,1.45,0,0,0,.55.367Z",
    transform: "translate(0 0)",
    fill: "#f37320"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5702",
    "data-name": "Group 5702",
    transform: "translate(494.581 278.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3425",
    "data-name": "Path 3425",
    d: "M11095,20312.166h79.356",
    transform: "translate(-11094.998 -20302.869)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3427",
    "data-name": "Path 3427",
    d: "M11187.422,20279.7l8.88,9.055-8.88,9.537",
    transform: "translate(-11114.779 -20279.695)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_tick_3923816-2",
    "data-name": "noun_tick_3923816",
    transform: "translate(577.564 182.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3432-2",
    "data-name": "Path 3432",
    d: "M18.237,2A16.237,16.237,0,1,0,34.474,18.237,16.237,16.237,0,0,0,18.237,2Zm9.216,13.374L17.711,24.3a1.624,1.624,0,0,1-2.246-.049l-4.871-4.871a1.624,1.624,0,1,1,2.3-2.3l3.772,3.772,8.6-7.88a1.624,1.624,0,0,1,2.2,2.393Z",
    transform: "translate(-2 -2)",
    fill: "#f37320"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_Cross_2135404",
    transform: "translate(669.594 182.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3438",
    "data-name": "Path 3438",
    d: "M16.237,0h0A16.237,16.237,0,0,0,0,16.237H0A16.237,16.237,0,0,0,16.237,32.474h0A16.237,16.237,0,0,0,32.474,16.237h0A16.237,16.237,0,0,0,16.237,0ZM21.8,19.472c.828.779,1.117,1.7.261,2.572s-1.776.6-2.573-.216l-3.3-3.4c-1.163,1.237-2.176,2.328-3.2,3.405-.791.829-1.725,1.073-2.571.2s-.545-1.791.278-2.572c1.049-1,2.1-1.992,3.577-3.4-1.274-1.078-2.422-2.019-3.529-3.005-.888-.792-1.22-1.77-.261-2.677.888-.838,1.805-.495,2.573.325.988,1.054,1.97,2.111,3.2,3.425,1.269-1.354,2.28-2.453,3.311-3.535a1.6,1.6,0,0,1,2.459-.21c.88.84.663,1.771-.166,2.569-1.075,1.034-2.167,2.05-3.5,3.3C19.627,17.442,20.718,18.452,21.8,19.472Z",
    transform: "translate(0 0)",
    fill: "#f37320"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_Man_4326500",
    transform: "translate(597.916 230.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3433",
    "data-name": "Path 3433",
    d: "M11.274,20.347l.639,1.911a1.865,1.865,0,0,0,1.767,1.277h1.958A1.865,1.865,0,0,0,17.4,22.258l.639-1.911-3.384-2.8Z",
    transform: "translate(27.255 67.022)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3434",
    "data-name": "Path 3434",
    d: "M10.122,17.422l8.857,8.857,8.857-8.857V13.94a21.533,21.533,0,0,1-11.491,1.795,22.749,22.749,0,0,1-6.251-1.725Z",
    transform: "translate(22.934 53.376)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    d: "M12.042,15a.117.117,0,0,0-.158,0L8.662,18.217l5.594,12.619a.107.107,0,0,0,.079.065.126.126,0,0,0,.1,0l7.347-6.126Z",
    transform: "translate(17.691 57.392)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    d: "M22.278,15.014l-9.757,9.752,7.361,6.126a.1.1,0,0,0,.1,0,.089.089,0,0,0,.075-.065l1.977-4.433,3.636-8.181-3.221-3.221a.107.107,0,0,0-.168.023Z",
    transform: "translate(31.821 57.377)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3437",
    "data-name": "Path 3437",
    d: "M78.748,79.855l-14.74-5.373a1.711,1.711,0,0,0-.406-.717l-4.018-4.142a3.329,3.329,0,0,0-2.508-1.02V65.236a22.325,22.325,0,0,0,6.993-7.317,23.656,23.656,0,0,0,2.559-6.095,24.211,24.211,0,0,0,.774-6.095c0-14.768,0-14.537-.037-15.144a1.75,1.75,0,0,0-.96-1.516,1.649,1.649,0,0,0-1.746.177A1.773,1.773,0,0,0,64,30.927c.037.394,0,.736,0,14.8,0,10.943-8.595,19.815-19.2,19.815S25.6,56.672,25.6,45.729c0-3.9-.04-6.845-.054-9.241a8.976,8.976,0,0,1,3.256-7.03A8.388,8.388,0,0,1,36.182,27.8C44,29.72,47.151,34.766,57.16,34.285A1.744,1.744,0,0,0,57,30.8c-9.067.438-11.5-4.277-20.045-6.393A11.684,11.684,0,0,0,26.7,26.75a12.5,12.5,0,0,0-4.517,9.781c0,1.741.033,3.848.047,6.379a3.613,3.613,0,0,1-1.893-3.185V18.506a4.079,4.079,0,0,1,4.009-4.137,1.689,1.689,0,0,0,1.566-1.092A15.036,15.036,0,0,1,39.935,3.483H54.311A15.46,15.46,0,0,1,69.5,19.16V39.726a1.688,1.688,0,1,0,3.375,0V19.16C72.866,8.584,64.561.013,54.311,0H39.935A18.341,18.341,0,0,0,23.2,10.978a7.565,7.565,0,0,0-6.251,7.528V39.726a7.072,7.072,0,0,0,5.305,6.889c.047,0,.117,1.674.135,1.842q.107.924.28,1.833A23.428,23.428,0,0,0,32,64.942c.247.173.522.3.779.481v3.213a3.333,3.333,0,0,0-2.513,1.02L26.248,73.8a1.7,1.7,0,0,0-.406.722L13.288,79.09l-3.263,1.256A12.6,12.6,0,0,0,3.009,91.7v22.08a1.636,1.636,0,0,0,3.263,0V91.7a9.449,9.449,0,0,1,.573-3.228l8.289,7.3A5.6,5.6,0,0,1,17,99.982v13.773a1.712,1.712,0,0,0,.761,1.616,1.6,1.6,0,0,0,1.741,0,1.712,1.712,0,0,0,.761-1.616V99.982a9.04,9.04,0,0,0-3.016-6.773L8.561,85.527a8.844,8.844,0,0,1,3.613-2.482l14.61-5.32,5.17,12.026a3.388,3.388,0,0,0,2.331,1.987,3.263,3.263,0,0,0,2.942-.717l1.59-1.371.233.722a5.352,5.352,0,0,0,1.436,2.261L37.124,113.5a1.688,1.688,0,0,0,1.347,1.924,1.762,1.762,0,0,0,.27,0,1.662,1.662,0,0,0,1.618-1.414l3.231-20.07h2.625l3.263,20.07a1.652,1.652,0,0,0,1.613,1.414,1.709,1.709,0,0,0,.27,0,1.683,1.683,0,0,0,1.347-1.924l-3.38-20.863a5.308,5.308,0,0,0,1.445-2.266L51,89.654,52.6,91.02a3.276,3.276,0,0,0,2.158.813,3.391,3.391,0,0,0,3.109-2.078L59.8,85.248h0l.545-1.26h0l2.662-6.254,14.633,5.335a8.844,8.844,0,0,1,3.608,2.477l-8.685,7.7a9.03,9.03,0,0,0-3.021,6.773v13.773a1.712,1.712,0,0,0,.761,1.616,1.6,1.6,0,0,0,1.741,0,1.712,1.712,0,0,0,.761-1.616v-13.8a5.618,5.618,0,0,1,1.865-4.2l8.289-7.326a9.32,9.32,0,0,1,.573,3.228V113.76a1.712,1.712,0,0,0,.761,1.616,1.6,1.6,0,0,0,1.741,0,1.712,1.712,0,0,0,.761-1.616V91.684a12.541,12.541,0,0,0-8.051-11.829ZM48.829,68.68A21.762,21.762,0,0,0,53.8,67.054v3.593l-8.876,9.159-8.857-9.14V67.15a22.2,22.2,0,0,0,6.251,1.78,21.5,21.5,0,0,0,6.512-.241Zm-13.7,19.728a.122.122,0,0,1-.1,0,.108.108,0,0,1-.079-.067L29.362,75.319l3.221-3.324a.114.114,0,0,1,.159,0l9.752,10.068Zm12.521.876A1.871,1.871,0,0,1,45.888,90.6H43.93a1.871,1.871,0,0,1-1.767-1.318l-.639-1.972,3.384-2.886,3.384,2.886Zm9.184-5.494-1.977,4.575a.09.09,0,0,1-.075.067.1.1,0,0,1-.1,0l-7.352-6.321,9.757-10.064a.105.105,0,0,1,.159,0l3.221,3.324Z",
    transform: "translate(-3.009 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6313",
    "data-name": "Group 6313",
    transform: "translate(1.903 1.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3575",
    "data-name": "Path 3575",
    d: "M13254.685,2933.965h28.455s-.79-14.3-14-14.412-14.458,10.032-14.458,10.032",
    transform: "translate(-12631 -2737)",
    fill: "none",
    stroke: "#f37320",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3576",
    "data-name": "Path 3576",
    d: "M13255.44,2943.154s4.947,8.9,13.045,8.511,10.829-4.277,13.468-8.256",
    transform: "translate(-12631.098 -2740.045)",
    fill: "none",
    stroke: "#f37320",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6316",
    "data-name": "Group 6316",
    transform: "translate(-0.17 0.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3577",
    "data-name": "Path 3577",
    d: "M13083.938,3032.2v-65.413h-89.786v105.467h89.786v-16.409",
    transform: "translate(-12631 -2737)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3579",
    "data-name": "Path 3579",
    d: "M13006.96,2984.087h63.068",
    transform: "translate(-12631 -2737)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3580",
    "data-name": "Path 3580",
    d: "M13006.96,2984.087h63.068",
    transform: "translate(-12631 -2723)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3581",
    "data-name": "Path 3581",
    d: "M13006.96,2984.087h29.743",
    transform: "translate(-12631 -2706)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3582",
    "data-name": "Path 3582",
    d: "M13006.96,2984.087h29.743",
    transform: "translate(-12631 -2692)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3583",
    "data-name": "Path 3583",
    d: "M13006.96,2984.087h29.743",
    transform: "translate(-12631 -2678)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3584",
    "data-name": "Path 3584",
    d: "M13006.96,2984.087h29.743",
    transform: "translate(-12631 -2664)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3585",
    "data-name": "Path 3585",
    d: "M13047.6,3025.169l10.6-9.764,11.453,9.764",
    transform: "translate(-12631 -2737)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3586",
    "data-name": "Path 3586",
    d: "M13058.121,3015.4v40.008",
    transform: "translate(-12631 -2737)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper1);
export default __webpack_public_path__ + "static/media/stepper1.a27e52f798f810c2a61e7daf9bd2e82c.svg";
export { ForwardRef as ReactComponent };